/**
 * CTO Directive #120.1 §3 — Preview environment indicator.
 *
 * Shown ONLY when we're inside the Emergent preview environment.
 * Native EXE / DMG / PKG / APK builds will point at a real MEOS
 * mesh endpoint (no ``preview.emergentagent.com`` in the URL) and
 * this component renders nothing.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const IS_PREVIEW = /preview\.emergentagent\.com/i.test(BACKEND_URL);

export function PreviewBadge() {
  if (!IS_PREVIEW) return null;
  return (
    <div
      data-testid="preview-environment-badge"
      style={{
        position: "fixed",
        bottom: 8,
        right: 12,
        padding: "4px 10px",
        borderRadius: 999,
        background: "rgba(0, 0, 0, 0.55)",
        color: "rgba(255, 255, 255, 0.9)",
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: 0.4,
        zIndex: 9999,
        pointerEvents: "none",
        backdropFilter: "blur(6px)",
      }}
    >
      MEOS Preview Environment
    </div>
  );
}
